.container {
  position: relative;

  /* Global to be able to give custom styling */
  :global(.formatted-overlay) {
    position: absolute;
    background: white;

    /* Mouse clicks should go through the overlay, to the actual input */
    pointer-events: none;

    /* When selecting and copying the whole page, prevent copying the overlay value as well */
    user-select: none;

    /* Same as input border */
    inset: 2px;

    /* Same as reset.css input */
    padding: 1px 2px;

    display: flex;
    > span {
      /* Vertical center, horizontal grow to be able to align right */
      align-self: center;
      flex-grow: 1;
    }
  }

  input:disabled {
    border: solid var(--bg-gray-darkest);
    background: var(--bg-gray-darker);
  }
}
